import { render, staticRenderFns } from "./LentiVista.vue?vue&type=template&id=06e65575&scoped=true"
import script from "./LentiVista.vue?vue&type=script&lang=ts"
export * from "./LentiVista.vue?vue&type=script&lang=ts"
import style0 from "./LentiVista.vue?vue&type=style&index=0&id=06e65575&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e65575",
  null
  
)

export default component.exports